module.exports = __webpack_public_path__ + "static/media/eye.c1c589c8.svg";